import type { RootState } from '@app/store';
import { ROUTES } from '@app/store';

export const selectRoutes = (state: RootState) =>
  state[ROUTES].allSessionRoutes;
